export default __webpack_public_path__ + "static/media/ELECTIVE_COOKING_BAKING.a78d1d78.svg";